import React, { useEffect, useState } from 'react';
import { Switch } from '@mui/material';
import PropTypes from 'prop-types';

const SwitchCell = ({ value, fallbackValue, disabledToggle }) => {
  const [checked, setChecked] = useState(!!value);

  const handleChange = async (e) => {
    setChecked(e.target.checked);

    try {
      await fallbackValue(e);
    } catch {
      setChecked(!!value);
    }
  };

  useEffect(() => {
    setChecked(!!value);
  }, [value]);

  return (
    <Switch
      aria-label="status"
      color="primary"
      checked={checked}
      onChange={handleChange}
      disabled={disabledToggle}
    />
  );
};

SwitchCell.propTypes = {
  value: PropTypes.any.isRequired,
  fallbackValue: PropTypes.func.isRequired,
  disabledToggle: PropTypes.bool.isRequired,
};

export default SwitchCell;
